export default "__VITE_ASSET__Di_gKDyA__"